// extracted by mini-css-extract-plugin
export default {"menuNavPage":"style_menuNavPage__HYBf8","menuNavAction":"style_menuNavAction__JcQdZ"};